import { photoBookIds } from 'src/api/productTypes';

// eslint-disable-next-line import/prefer-default-export
export const isPhotobook = (productTypeId: number) => photoBookIds.indexOf(productTypeId) >= 0;

// Apparel-ness comes from the BE integration layer (ProductType::$apparelProductTypes) — the single
// source of truth. The FE no longer maintains its own product-type list.
export const isApparelProduct = () => !!window.integrationLayer?.isApparel;

const SIMPLE_PHOTO_MUGS = ['simple-photo', 'simple-photo-left'];

export const checkSimplePhotoMug = (attributeValue: string) => SIMPLE_PHOTO_MUGS.indexOf(attributeValue) !== -1;
